export default "__VITE_ASSET__DB1Eitlj__";